module.exports = __webpack_public_path__ + "static/media/nav-icon-users.63a3d11a.svg";